import React from "react";
import { Badge } from "@/components/ui/badge";
import { FileText, Clock, CheckCircle2, AlertCircle, Zap } from "lucide-react";

export default function TechnicalSheetStatusBadge({ status, source }) {
  const statusConfig = {
    missing: {
      label: "Sense fitxa",
      className: "bg-gray-100 text-gray-700",
      icon: AlertCircle
    },
    uploaded: {
      label: "Carregada",
      className: "bg-blue-100 text-blue-700",
      icon: FileText
    },
    ai_generated: {
      label: "Generada per IA",
      className: "bg-purple-100 text-purple-700",
      icon: Zap
    },
    pending_review: {
      label: "Pendent revisió",
      className: "bg-amber-100 text-amber-700",
      icon: Clock
    },
    validated: {
      label: "Validada",
      className: "bg-emerald-100 text-emerald-700",
      icon: CheckCircle2
    }
  };

  const config = statusConfig[status] || statusConfig.missing;
  const Icon = config.icon;

  return (
    <div className="flex items-center gap-1.5">
      <Icon className="w-3.5 h-3.5" />
      <Badge className={`${config.className} border-0`}>{config.label}</Badge>
    </div>
  );
}